import React from 'react';

const DeviceSVG = () => (
  <svg
    width="251"
    height="505"
    viewBox="-1 -1 251 505"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <rect id="a" width="250" height="504" rx="32.189" />
      <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="b">
        <feGaussianBlur stdDeviation="3" in="SourceAlpha" result="shadowBlurInner1" />
        <feOffset dy="6" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0.839340377 0 0 0 0 0.839340377 0 0 0 0 0.888286565 0 0 0 1 0"
          in="shadowInnerInner1"
          result="shadowMatrixInner1"
        />
        <feMorphology radius="2" in="SourceAlpha" result="shadowSpreadInner2" />
        <feGaussianBlur stdDeviation="4" in="shadowSpreadInner2" result="shadowBlurInner2" />
        <feOffset dy="-4" in="shadowBlurInner2" result="shadowOffsetInner2" />
        <feComposite
          in="shadowOffsetInner2"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner2"
        />
        <feColorMatrix
          values="0 0 0 0 0.839215686 0 0 0 0 0.839215686 0 0 0 0 0.890196078 0 0 0 1 0"
          in="shadowInnerInner2"
          result="shadowMatrixInner2"
        />
        <feMerge>
          <feMergeNode in="shadowMatrixInner1" />
          <feMergeNode in="shadowMatrixInner2" />
        </feMerge>
      </filter>
      <linearGradient x1="-36.708%" y1="-156.185%" y2="227.148%" id="c">
        <stop stopColor="#ABA3A3" offset="0%" />
        <stop offset="100%" />
      </linearGradient>
      <rect id="d" x="105.15" y="20.224" width="39.7" height="4.513" rx="2.257" />
      <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="e">
        <feGaussianBlur stdDeviation="1" in="SourceAlpha" result="shadowBlurInner1" />
        <feOffset dy="2" in="shadowBlurInner1" result="shadowOffsetInner1" />
        <feComposite
          in="shadowOffsetInner1"
          in2="SourceAlpha"
          operator="arithmetic"
          k2="-1"
          k3="1"
          result="shadowInnerInner1"
        />
        <feColorMatrix
          values="0 0 0 0 0.0212053571 0 0 0 0 0.0212053571 0 0 0 0 0.0212053571 0 0 0 0.905938632 0"
          in="shadowInnerInner1"
        />
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g transform="rotate(-180 125 252)">
        <use fill="#FFF" xlinkHref="#a" />
        <use fill="#000" filter="url(#b)" xlinkHref="#a" />
      </g>
      <g opacity=".103">
        <use fill="url(#c)" xlinkHref="#d" />
        <use fill="#000" filter="url(#e)" xlinkHref="#d" />
      </g>
      <ellipse
        stroke="#DDD"
        strokeWidth="1.073"
        fill="#FFF"
        cx="125"
        cy="478.191"
        rx="11.803"
        ry="11.821"
      />
    </g>
  </svg>
);

export default DeviceSVG;



// WEBPACK FOOTER //
// ./src/components/LockHomeDemo/svg/DeviceSVG.js